import { HttpContextToken, HttpHeaders, HttpParams } from '@angular/common/http';

/**
 * Marks a request that has already been retried with a freshly refreshed token. Without it, a 401
 * on the retried request would start a second refresh cycle for a session the server just refused.
 */
export const TOKEN_REFRESHED = new HttpContextToken<boolean>(() => false);

/** A request that must never trigger the refresh-on-401 machinery (public endpoints). */
export const IS_PUBLIC_API = new HttpContextToken<boolean>(() => false);

export interface ApiOptionInterface {
    excludeFields?: string[];
    exposeHeaders?: {
        [key: string]: string | string[]
    };
    loader?: boolean;
    pretreatmentResponse?: boolean;
    requestOptions?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe?: string | any;
        params?: HttpParams | {
            [param: string]: string | string[];
        };
        reportProgress?: boolean;
        responseType?: string | any;
        withCredentials?: boolean;
    };
}
